var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7305 45.8994L34.7729 31.9421C37.5183 28.5659 39.016 24.3467 39.0137 19.9952C39.0137 9.5084 30.4819 0.976562 19.9951 0.976562C9.5083 0.976562 0.976562 9.5084 0.976562 19.9952C0.976562 30.482 9.5084 39.0137 19.9952 39.0137C24.3467 39.0159 28.5659 37.5182 31.9421 34.7729L45.8994 48.7305C45.9924 48.8235 46.1028 48.8972 46.2242 48.9475C46.3457 48.9979 46.4759 49.0238 46.6074 49.0238C46.7389 49.0238 46.8691 48.9979 46.9906 48.9475C47.1121 48.8972 47.2225 48.8235 47.3154 48.7305L48.7305 47.3149C48.9182 47.1272 49.0236 46.8726 49.0236 46.6072C49.0236 46.3417 48.9182 46.0871 48.7305 45.8994ZM19.9952 35.0098C11.7156 35.0098 4.98047 28.2748 4.98047 19.9952C4.98047 11.7156 11.7156 4.98047 19.9952 4.98047C28.2748 4.98047 35.0098 11.7156 35.0098 19.9952C35.0098 28.2748 28.2748 35.0098 19.9952 35.0098Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search_white.a13d7c2c79d8da48489bef935b773852.svg";
export { ForwardRef as ReactComponent };